import { ModelSagres } from "../model-sagres";

//Interfaces para a tipagem
interface IdRegraTransicaoNavigation {
    IdRegraTransicao: number;
    DeRegraTransicao: string;
    TpDocTce: number;
}

interface ArquivoAposentadoria{
    IdArquivo: number;
    IdAposentadoria: number;
    NmArquivo: string;
    PathArquivo: string;
    TamArquivo: number;
    IdTipoArquivo: number
    IdTipoArquivoNavigation: {
        IdTipoArquivo: number;
        DeTipoArquivo: string;
    }
}

interface ContribuicaoAposentadoria{
    IdContribuicao: number
    IdAposentadoria: number
    IdTipoContribuicao: number
    Desconto: number
    DtInicial: string
    DtFinal: string
    IdTipoContribuicaoNavigation: {
        IdTipoContribuicao: number
        DeTipoContribuicao: string
    }
}

interface ProventoAposentadoria {
    IdProvento: number
    IdAposentadoria: number
    DeProvento: string
    VlProvento: number
}




export class Aposentadoria extends ModelSagres {
    IdAposentadoria: number;
    idUnidGestora?: string; 
    NrProcesso: string;
    NmAposentado: string;
    DtNascimento: string;
    DtRequerimento: string;
    DeSexo: string;
    NrCpf: string;
    NrRg: string;
    DeOrgaoEmissorRg: string;
    idRegraTransicao?: number 
    AnoPortaria: number;
    NrPortaria: number;
    DtPortaria: string;
    DeCargo: string;
    DeEnquadramento: string;
    DeOrgaoAposentadoria: string;
    NrDiasMajoracao?: number;
    NrDiasFalta?: number;
    FlCompensacao?: boolean;
    CpfUsuario?: string;
    CdProtocolo?: number;
    CdProtocoloTce?: string;
    DtCriacao: string;
    DtAlteracao?: string;
    DtExclusao: string;
    CpfExclusao?: string;
    IdRegraTransicaoNavigation?: IdRegraTransicaoNavigation;
    ArquivoAposentadoria?: ArquivoAposentadoria[];
    ContribuicaoAposentadoria?: ContribuicaoAposentadoria[];
    ProventoAposentadoria?: ProventoAposentadoria[];
    
    constructor(obj?: any){
        //console.log(obj)
        super()
        if(obj.IdAposentadoria)this.IdAposentadoria = obj.IdAposentadoria;
        if(obj.idUnidGestora)this.idUnidGestora = obj.idUnidGestora;
        if(obj.NrProcesso)this.NrProcesso = obj.NrProcesso;
        if(obj.NmAposentado)this.NmAposentado = obj.NmAposentado;
        if(obj.DtNascimento)this.DtNascimento = obj.DtNascimento;
        if(obj.DtRequerimento)this.DtRequerimento = obj.DtRequerimento;
        if(obj.DeSexo)this.DeSexo = obj.DeSexo;
        if(obj.NrCpf)this.NrCpf = obj.NrCpf;
        if(obj.NrRg)this.NrRg = obj.NrRg;
        if(obj.DeOrgaoEmissorRg)this.DeOrgaoEmissorRg = obj.DeOrgaoEmissorRg;
        if(obj.idRegraTransicao) this.idRegraTransicao = obj.idRegraTransicao
        if(obj.AnoPortaria)this.AnoPortaria = obj.AnoPortaria;
        if(obj.NrPortaria)this.NrPortaria = obj.NrPortaria;
        if(obj.DtPortaria)this.DtPortaria = obj.DtPortaria;
        if(obj.DeCargo)this.DeCargo = obj.DeCargo;
        if(obj.DeEnquadramento)this.DeEnquadramento = obj.DeEnquadramento;
        if(obj.DeOrgaoAposentadoria)this.DeOrgaoAposentadoria = obj.DeOrgaoAposentadoria;
        if(obj.NrDiasMajoracao)this.NrDiasMajoracao = obj.NrDiasMajoracao;
        if(obj.NrDiasFalta)this.NrDiasFalta = obj.NrDiasFalta;
        if(obj.FlCompensacao)this.FlCompensacao = obj.FlCompensacao;
        if(obj.CpfUsuario)this.CpfUsuario = obj.CpfUsuario;
        if(obj.CdProtocolo)this.CdProtocolo = obj.CdProtocolo;
        if(obj.CdProtocoloTce)this.CdProtocoloTce = obj.CdProtocoloTce;
        if(obj.DtCriacao)this.DtCriacao = obj.DtCriacao;
        if(obj.DtAlteracao)this.DtAlteracao = obj.DtAlteracao;
        if(obj.DtExclusao)this.DtExclusao = obj.DtExclusao;
        if(obj.DtExclusao === null)this.DtExclusao = "";
        if(obj.CpfExclusao)this.CpfExclusao = obj.CpfExclusao;
        if(obj.IdRegraTransicaoNavigation)this.IdRegraTransicaoNavigation = obj.IdRegraTransicaoNavigation;
        if(obj.ArquivoAposentadoria) this.ArquivoAposentadoria = obj.ArquivoAposentadoria;
        if(obj.ContribuicaoAposentadoria)this.ContribuicaoAposentadoria = obj.ContribuicaoAposentadoria;
        if(obj.ProventoAposentadoria)this.ProventoAposentadoria = obj.ProventoAposentadoria;
    }
}